import { render, staticRenderFns } from "./stiticenotes.vue?vue&type=template&id=76e66858&scoped=true"
import script from "./stiticenotes.vue?vue&type=script&lang=js"
export * from "./stiticenotes.vue?vue&type=script&lang=js"
import style0 from "./stiticenotes.vue?vue&type=style&index=0&id=76e66858&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e66858",
  null
  
)

export default component.exports